<template>
  <div :id="floatingUnit.device_id" class="floating-unit-card">
    <div class="wrapper pt-2">
      <div class="floating-unit-icon">
        <img class="icon" :src="iconFloatingUnitBuoy" sizes="32px" alt="" />
      </div>
      <div class="floating-unit-label aisea-text-16-700-white">
        <div>{{ floatingUnit.label || "－" }}</div>
      </div>
      <div class="battery-icon">
        <battery-status :batteryLevel="floatingUnit.battery"></battery-status>
      </div>
      <div
        class="floating-unit-info aisea-text-12-400-white flex flex-col gap-2"
      >
        <div class="flex gap-2">
          <div class="flex items-center">
            <vs-icon
              icon-pack="feather"
              icon="icon-clock"
              size="14px"
            ></vs-icon>
          </div>
          <div class="flex items-center">
            <span>{{ edgeTimestamp }}</span>
          </div>
        </div>
        <div class="flex gap-2">
          <div class="flex items-center">
            <vs-icon
              icon-pack="feather"
              icon="icon-map-pin"
              size="14px"
            ></vs-icon>
          </div>
          <div class="flex">
            <span>{{ lonLat }}</span>
          </div>
          <div class="flex">
            <CopyToClipboard
              v-if="hasLocation"
              copyTooltipText="緯度経度をコピー"
              ref="copyToClipboard"
              @click.native="copyLngLat()"
            ></CopyToClipboard>
          </div>
        </div>
        <div class="flex gap-2">
          <div class="flex items-center">
            <vs-icon icon-pack="feather" icon="icon-cpu" size="15px"></vs-icon>
          </div>
          <div class="flex items-center">
            <span>{{ floatingUnit.device_id || "－" }}</span>
          </div>
        </div>
      </div>
      <div
        class="map-jump-button flex justify-center cursor-pointer"
        :class="{ disabled: !hasLocation }"
        @click="jumpTo()"
      >
        <div class="flex items-center">
          <vs-icon
            icon-pack="feather"
            icon="icon-map-pin"
            size="14px"
          ></vs-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BatteryStatus from "@/components/status/BatteryStatus.vue";
import CopyToClipboard from "@/components/tools/CopyToClipboard.vue";
import { createNamespacedHelpers } from "vuex";
import { toYMDHM, toGeoLabel } from "@/filter.js";

const { mapMutations: mapMutationsOfLiveMap } = createNamespacedHelpers(
  "liveMap"
);

export default {
  components: { BatteryStatus, CopyToClipboard },
  props: {
    floatingUnit: { type: Object, default: null },
  },
  data() {
    return {
      iconFloatingUnitBuoy: require("@/assets/images/icons/floating-unit/buoy.svg"),
    };
  },
  computed: {
    isSearchedFloatingUnit() {
      if (this.searchKeyword === "") return true;
      return this.floatingUnit.label
        .toLowerCase()
        .includes(this.searchKeyword.toLowerCase());
    },
    hasLocation() {
      return this.floatingUnit.location !== null;
    },
    edgeTimestamp() {
      if (
        !this.floatingUnit.edge_timestamp ||
        !this.floatingUnit.edge_timestamp.seconds
      ) {
        return "－";
      }
      const millisecondTimestamp =
        this.floatingUnit.edge_timestamp.seconds * 1000;
      return toYMDHM(millisecondTimestamp);
    },
    lonLat() {
      if (!this.floatingUnit.location) {
        return "－";
      } else {
        return `${toGeoLabel(
          this.floatingUnit.location.latitude
        )}, ${toGeoLabel(this.floatingUnit.location.longitude)}`;
      }
    },
  },
  methods: {
    ...mapMutationsOfLiveMap(["SET_JUMP_TO_MAP"]),
    jumpTo() {
      let isOpenNavMenu = this.$store.state.verticalNavMenuWidth === "default";
      let longitudeDiff = isOpenNavMenu ? 0.0039 : 0.00195; // mapジャンプした時に真ん中にするため調整
      let lon = this.floatingUnit.location.longitude + longitudeDiff;
      let lat = this.floatingUnit.location.latitude;

      this.SET_JUMP_TO_MAP({
        center: [lon, lat],
        zoom: 16,
      });
    },
    async copyLngLat() {
      let lat = Math.round(this.floatingUnit.location.latitude * 1e7) / 1e7;
      let lon = Math.round(this.floatingUnit.location.longitude * 1e7) / 1e7;
      await this.$refs.copyToClipboard.copyToClipboard(`${lat}, ${lon}`);
    },
  },
};
</script>

<style scoped lang="scss">
.floating-unit-card {
  border-radius: 5px;
  background: #3d4656;
}
.wrapper {
  display: grid;
  grid-template-columns: 80px 214px 1fr;
  grid-template-rows: 1fr 88px;
}
.floating-unit-icon {
  grid-area: 1 / 1 / 3 / 2;
  justify-self: center;
  align-self: center;
}
.floating-unit-label {
  grid-area: 1 / 2 / 2 / 3;
  justify-self: start;
  align-self: center;
  word-break: break-all;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.battery-icon {
  grid-area: 1 / 3 / 2 / 4;
  justify-self: center;
  align-self: center;
}
.floating-unit-info {
  grid-area: 2 / 2 / 3 / 3;
  justify-self: start;
  align-self: center;
  overflow-wrap: anywhere;
}
.map-jump-button {
  grid-area: 2 / 3 / 3 / 4;
  justify-self: end;
  align-self: end;
  border-radius: 6px;
  width: 32px;
  height: 32px;
  background: #2d9cdb;
  color: #f2f2f2;
  margin-right: 10px;
  margin-bottom: 14px;
}

.map-jump-button.disabled {
  background: var(--BlueGreen-700, #434e61);
  color: #64748b;
  pointer-events: none;
}
</style>
